export const AUTH_CONFIG = {
    clientId: '4eZxK0dHWtsu5MAvYD5ZmbuGl7fqlzWh',
    domain: 'openanalysis.auth0.com',
    //callbackUrl: 'http://localhost:8080/',
    callbackUrl: 'https://www.unpac.me/',
    apiUrl: 'api.unpac.me',
};



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js